import { DeterministicView } from '@bingads-webui/deterministic-view';
import paginationTemplate from '../template/contents/pager.pug';

/** The View class of page content */
export class PagerView extends DeterministicView {
  get template() {
    return paginationTemplate;
  }
  initialize({
    i18n,
  }) {
    this.i18n = i18n;
  }
  /**
   * Set the current page
   * @param {Object} currentPage the current page state.
   * @param {int} pageSize set the index of current page in pages array as currentPage.
   * @returns {PagerView} - The view itself
   */
  setPager({
    currentPage,
    pageSize,
  }) {
    return this.setState({
      pageSize,
      currentPage,
      popUpText: {
        prevPage: this.i18n.getString('Grid_PreviousPage'),
        nextPage: this.i18n.getString('Grid_NextPage'),
        pageOf: this.i18n.getString('Grid_PageOf'),
      },
    });
  }
}
